/* unplugin-vue-components disabled */import { render } from "./topHeader.vue?vue&type=template&id=4705b4e0&scoped=true"
import script from "./topHeader.vue?vue&type=script&lang=js"
export * from "./topHeader.vue?vue&type=script&lang=js"

import "./topHeader.vue?vue&type=style&index=0&id=4705b4e0&lang=less&scoped=true"

import exportComponent from "/Users/iwowke/Desktop/work/www/iwowke.com/src/m/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4705b4e0"]])

export default __exports__